import { createSlice } from '@reduxjs/toolkit';
import { MenuProps } from 'types/menu';

const initialState: MenuProps = {
    drawerOpen: false,
};

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        openDrawer(state, action) {
            state.drawerOpen = action.payload;
        },
    },
});

export default menu.reducer;

export const { openDrawer } = menu.actions;
